<main class="content">
  <router-outlet />
  @if (showSpinner) {
  <div class="custom-overlay">
    <div class="center">
      <app-infinity-loader></app-infinity-loader>
    </div>
  </div>
  }
</main>
